<a class="genLink" (click)="startGenerate()">
  <ng-content></ng-content>
</a>



